module.exports = __webpack_public_path__ + "static/media/how-does-it-work.f72617ec.png";